module.exports = __webpack_public_path__ + "static/uidesign-b2aa14905c53439172040577300c0e1b.png";